module.exports = __webpack_public_path__ + "static/media/auxilio_icon.29d30c7a.png";